<template>
    <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="content">
            <div class="row">
          
    
                <div class="col-md-12 rolelist">
                    <div class="addrole">

                        <router-link to="/admin/dashboard/addpromotion"><a class="">Add Promotion</a></router-link>
                    </div>
                </div>
    
                <div class="col-md-12 rolelistupper">
                    <div class="card">
<h5 class="card-title">Promotion List</h5>

                        <FlashMessage :position="'right top'"></FlashMessage>
    
                        <div class="card-body table-responsive table-full-width">
    
                            <table class="table table-borderd mt-5" id="myTable">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Promotion</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in tableData" v-bind:key="data.promotionid">
                                        <td>{{data.promotionid}}</td>
                                        <td>{{data.promotion}}</td>
                                        <td>{{data.status}}</td>
                                        <td><button @click.prevent="deleteData(data.promotionid)" class="btnborderremove">
                                                <a><b-icon-trash></b-icon-trash></a>
                                            </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editpromotion/' + data.promotionid"><button class="btnborderremove">
                                                    <a><b-icon-pencil-square></b-icon-pencil-square></a>
                                                </button></router-link>
                                        </td>
    
                                    </tr>
                                </tbody>
    
                            </table>
    
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <content-footer></content-footer>
    </div>
    </template>
    
    <script>
    import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
    import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
    import datatable from "datatables.net-bs4"
    import Auth from '../../../Auth.js';
    import Vue from 'vue'
    import $ from "jquery"
    import {
        Table,
        TableColumn
    } from 'element-ui'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        name: 'listPromotion',
    
        components: {
            TopNavbar,
            ContentFooter,
        },
    
        data() {
            return {
                tableData: [],
                Auth: '',
            }
        },
    
        methods: {
    
            table() {
                this.$nextTick(() => {
                    $('#myTable').DataTable();
                });
            },
    
            getData() {
                this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/promotion`).then((res) => {
                    this.tableData = res.data;
                    this.table();
    
                });
            },
    
            deleteData(promotionid) {
                this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/promotion/delete/` + promotionid).then((res) => {
                    this.list = res;
                    this.getData();
                    this.flashMessage.success({
                        message: 'Promotion Deleted Successfully'
                    });
                });
            },
    
        },
    
        mounted() {
            this.getData();
            this.Auth = Auth.user;
        },
    
    };
    </script>
    
    <style lang="scss">
    
    </style>
    